<template>
    <div>
        <template v-if="!invited">
            <div class="text-center mt-5">
                <span class="badge badge-pill">Мы открылись!</span>
            </div>

            <div class="page-header mt-2 mb-5 text-center">
                <h1>Новый магазин «Baden»</h1>

                <h3>ТЦ «Терминал», 1 этаж</h3>
            </div>

            <p class="text-center mb-4">Ждём вас ежедневно с 10:00 до 21:00</p>

<!--            <div class="row justify-center q-col-gutter-x-md">
                <div class="col-12 col-sm-5 col-md-3">
                    <q-input square
                             outlined
                             v-model="form.name"
                             label="Ваше имя"
                             :error-message="form.errors.get('name')"
                             :error="form.errors.has('name')"
                             @keydown="form.errors.clear('name')">
                    </q-input>
                </div>
                <div class="col-12 col-sm-5 col-md-3">
                    <q-input square
                             outlined
                             v-model="form.phone_number"
                             label="Ваш телефон"
                             @blur="blurPhoneNumber"
                             @focus="focusPhoneNumber"
                             :fill-mask="fillPhoneNumberMask"
                             mask="+7 (###) ###-##-##"
                             :error-message="form.errors.get('phone_number')"
                             :error="form.errors.has('phone_number')"
                             @keydown="form.errors.clear('phone_number')">
                    </q-input>
                </div>
                <div class="col-12 col-sm-5 col-md-3">
                    <q-input square
                             outlined
                             v-model="form.email"
                             label="Ваша эл. почта"
                             :error-message="form.errors.get('email')"
                             :error="form.errors.has('email')"
                             @keydown="form.errors.clear('email')">
                    </q-input>
                </div>
            </div>-->
<!--            <div class="row justify-center q-col-gutter-x-md q-mb-xl">
                <div class="col-12 col-sm-5 col-md-3">
                    <q-btn color="primary"
                           class="q-field__marginal full-width"
                           label="Отправить заявку на приглашение"
                           @click="submit" />
                </div>
            </div>-->

            <div>
                <event-carousel v-if="images && images.length" :items="images"></event-carousel>
            </div>
        </template>

        <div v-if="invited" class="text-center mt-5">
            <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35.4043 70.365C54.7023 70.365 70.4043 54.6644 70.4043 35.365C70.4043 32.0339 69.9393 28.7512 69.0186 25.6074C68.565 24.0615 66.9507 23.1735 65.4005 23.6271C63.8532 24.0793 62.9681 25.6993 63.4202 27.2452C64.1829 29.8571 64.571 32.59 64.571 35.365C64.571 51.4472 51.4866 64.5317 35.4043 64.5317C19.322 64.5317 6.23763 51.4472 6.23763 35.365C6.23763 19.2827 19.322 6.19832 35.4043 6.19832C41.249 6.19832 46.8723 7.90731 51.666 11.1394C53.0004 12.0402 54.8148 11.6863 55.7142 10.3519C56.6142 9.01601 56.2632 7.20306 54.9273 6.303C49.1666 2.41862 42.4161 0.36499 35.4043 0.36499C16.1063 0.36499 0.404297 16.0656 0.404297 35.365C0.404297 54.6644 16.1063 70.365 35.4043 70.365Z" fill="#24AAFF"/>
                <path d="M65.4254 7.05098L35.4042 37.0707L25.7997 27.4676C24.6604 26.329 22.8147 26.329 21.6754 27.4676C20.5367 28.607 20.5367 30.4527 21.6754 31.592L33.342 43.2587C33.9124 43.829 34.6572 44.1132 35.4042 44.1132C36.1512 44.1132 36.896 43.829 37.4664 43.2587L69.5497 11.1753C70.6883 10.036 70.6883 8.1903 69.5497 7.05098C68.4104 5.91237 66.5647 5.91237 65.4254 7.05098Z" fill="#24AAFF"/>
            </svg>

            <div class="page-header mb-3 text-center">
                <h2>Заявка принята</h2>
            </div>

            <p>
                За день до открытия мы с вами свяжемся,<br />
                а так же пришлём приглашение на e-mail почту с промокодом на скидку 10%
            </p>
        </div>
    </div>
</template>

<script>
import { Form } from '../classes/Form';
import phoneNumberMixin from "../mixins/phone_number";

export default {
    name: "EventInvitation",
    props: {
        event: {
            type: Object,
            required: true
        },
        images: {
            type: Array,
            required: false,
            default: []
        }
    },
    mixins: [
        phoneNumberMixin,
    ],
    data () {
        return {
            form: new Form({
                name: '',
                phone_number: '',
                email: '',
            }),
            invited: false
        }
    },
    methods: {
        submit () {
            let _this = this;

            _this.form.post(`/events/${_this.event.id}/invitations`)
                .then(response => {
                    if (response.status === 'success') {
                        _this.invited = true;
                    }
                });
        },
        getPhoneNumber () {
            return this.form.phone_number;
        },
        setPhoneNumberCallback () {
            this.form.phone_number = '';
        }
    }
}
</script>
